export const IStatisticsApiId = Symbol.for('IStatisticsApi');

export interface IStatisticsApi {
    getMpcStatistics(calendarDay?: string): Promise<any[]>;
    getMpcStatisticsByDayLineDeparture(from: string, to: string): Promise<any>;
    getExportUrl(from: string, to: string): string;
}
